import React, { useState } from 'react';

const MainContent = () => {
    const [valx, setvalx] = useState(10);
    const [valy, setvaly] = useState(10);
    const [valblur, setvalblur] = useState(5);
    const [valspread, setvalspread] = useState(0);
    const [valopacity, setvalopacity] = useState(100);
    const [valcolor, setvalcolor] = useState("#000000");
    const [valbackcolor, setvalbackcolor] = useState("#ffffff");
    const [insetval, setinsetval] = useState(false);

    const changeX = (e) => {
        let Xvalue = document.getElementById("value-x");
        console.log("x changed");
        setvalx(e.target.value)
        Xvalue.value = valx;
    }

    const changeY = (e) => {
        let Yvalue = document.getElementById("value-y");
        console.log("y changed");
        setvaly(e.target.value)
        Yvalue.value = valy;
    }

    const changeblur = (e) => {
        let blurvalue = document.getElementById("value-blur");
        console.log("blur changed");
        setvalblur(e.target.value)
        blurvalue.value = valblur;
    }

    const changespread = (e) => {
        let spreadvalue = document.getElementById("value-spread");
        console.log("spread changed");
        setvalspread(e.target.value)
        spreadvalue.value = valspread;
    }

    const changeopacity = (e) => {
        let opacityvalue = document.getElementById("value-opacity");
        console.log("opacity changed");
        setvalopacity(e.target.value)
        opacityvalue.value = valopacity;
    }


    const changecolor = (e) => {
        let colorvalue = document.getElementById("colorcode").value;
        let rgbcode = document.getElementById("rgbcode");

        const hex2rgb = (hex) => {
            const r = parseInt(hex.slice(1, 3), 16)
            const g = parseInt(hex.slice(3, 5), 16)
            const b = parseInt(hex.slice(5, 7), 16)
            return [r, g, b]
        };

        rgbcode.innerText = `RGB(${hex2rgb(colorvalue)[0]},${hex2rgb(colorvalue)[1]},${hex2rgb(colorvalue)[2]})`;
        console.log(colorvalue);
        setvalcolor(e.target.value)
        colorvalue = valcolor;
    }

    const changebackcolor = (e) => {
        let backcolorvalue = document.getElementById("backAxis").value;
        let backrgbcode = document.getElementById("backrgbcode");

        const hex2rgb = (hex) => {
            const r = parseInt(hex.slice(1, 3), 16)
            const g = parseInt(hex.slice(3, 5), 16)
            const b = parseInt(hex.slice(5, 7), 16)
            return [r, g, b]
        };

        backrgbcode.innerText = `RGB(${hex2rgb(backcolorvalue)[0]},${hex2rgb(backcolorvalue)[1]},${hex2rgb(backcolorvalue)[2]})`;
        console.log(backcolorvalue);
        setvalbackcolor(e.target.value)
        backcolorvalue = valbackcolor;
        document.body.style.backgroundColor = valbackcolor;
    }

    const setShadowColor = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return [r, g, b]
    };

    const setinset = () => {
        if (insetval === true) {
            return 'inset';
        } else {
            return '';
        }
    }

    const getinsetVal = () => {
        if (insetval === true) {
            setinsetval(false)
        } else if (insetval === false) {
            setinsetval(true)
        }
    }


    const boxStyle = {
        boxShadow: `${valx}px ${valy}px ${valblur}px ${valspread}px rgba(${setShadowColor(valcolor)[0]},${setShadowColor(valcolor)[1]},${setShadowColor(valcolor)[2]},${valopacity / 100}) ${setinset()}`
    }

    const copy = () => {
        let code = document.getElementById("code").innerText;
        let copyBtn = document.getElementById("copyBtn");
        console.log(code);

        copyBtn.style.backgroundColor = "black";
        let inputElm = document.createElement("textarea");
        inputElm.value = code;
        document.body.appendChild(inputElm);
        inputElm.select();
        document.execCommand('copy');
        inputElm.parentNode.removeChild(inputElm);
        copyBtn.innerText = "copied...";
        setInterval(() => {
            copyBtn.style.backgroundColor = "#304f9c";
            copyBtn.innerText = "Copy";         
        }, 3000)
    }

    return (
        <div>
            <div className="container">
                <div className="left">
                    <h4>Shadow Options</h4>

                    {/* X Axis value */}
                    <div className="single">
                        <label htmlFor="xAxis">x-axis</label>
                        <div className="value">
                            <input type="range" id="xAxis" min="-200" max="200" onChange={changeX} value={valx} />
                            <input type="text" readOnly  value={`${valx}px`} id="value-x" min="-200" max="200" />
                        </div>
                    </div>

                    {/* Y Axix value */}
                    <div className="single">
                        <label htmlFor="yAxis">y-axis</label>
                        <div className="value">
                            <input type="range" id="yAxis" min="-200" max="200" onChange={changeY} value={valy} />
                            <input type="text" readOnly value={`${valy}px`} id="value-y" />
                        </div>
                    </div>

                    {/* Blur Radius */}
                    <div className="single">
                        <label htmlFor="blurAxis">Blur Radius</label>
                        <div className="value">
                            <input type="range" id="blurAxis" min="0" max="400" onChange={changeblur} value={valblur} />
                            <input type="text" readOnly value={`${valblur}px`} id="value-blur" />
                        </div>
                    </div>

                    {/* Spread Radius */}
                    <div className="single">
                        <label htmlFor="spreadAxis">Spread Radius</label>
                        <div className="value">
                            <input type="range" id="spreadAxis" min="-200" max="200" onChange={changespread} value={valspread} />
                            <input type="text" readOnly value={`${valspread}px`} id="value-spread" />
                        </div>
                    </div>

                    {/* Opacity Radius */}
                    <div className="single">
                        <label htmlFor="opacityAxis">Opacity Radius</label>
                        <div className="value">
                            <input type="range" id="opacityAxis" min="0" max="100" onChange={changeopacity} value={valopacity} />
                            <input type="text" readOnly value={`${valopacity / 100}`} id="value-opacity" />
                        </div>
                    </div>

                    {/* Shadow Color */}
                    <div className="single color">
                        <label htmlFor="opacityAxis">Shadow Color</label>
                        <div className="value">
                            <div className="input">
                                <p id="rgbcode">RGB(0,0,0)</p>
                            </div>
                            <input type="color" id="colorcode" onChange={changecolor} value={valcolor} />
                        </div>
                    </div>

                    {/* Background Color */}
                    <div className="single color">
                        <label htmlFor="backAxis">Background Color</label>
                        <div className="value">
                            <div className="input">
                                <p id="backrgbcode">RGB(255,255,255)</p>
                            </div>
                            <input type="color" id="backAxis" onChange={changebackcolor} value={valbackcolor} />
                        </div>
                    </div>

                    {/* Inset value */}
                    <div className="single check">
                        <label htmlFor="insetval">Inset</label>
                        <div className="value">
                            <input type="checkbox" id="insetval" value={insetval} onChange={getinsetVal} /></div>
                    </div>

                </div>
                <div className="right">
                    <div className="box" style={boxStyle}></div>
                </div>
            </div>
            <div className="source-code">
                <div className="left">
                    <div className="code" id="code">
                        <p>{`box-shadow: ${valx}px ${valy}px ${valblur}px ${valspread}px rgba(${setShadowColor(valcolor)[0]},${setShadowColor(valcolor)[1]},${setShadowColor(valcolor)[2]},${valopacity / 100})  ${setinset()};`} <br />
                        {`-webkit-box-shadow: ${valx}px ${valy}px ${valblur}px ${valspread}px rgba(${setShadowColor(valcolor)[0]},${setShadowColor(valcolor)[1]},${setShadowColor(valcolor)[2]},${valopacity / 100})  ${setinset()};`}<br />{`-moz-box-shadow: ${valx}px ${valy}px ${valblur}px ${valspread}px rgba(${setShadowColor(valcolor)[0]},${setShadowColor(valcolor)[1]},${setShadowColor(valcolor)[2]},${valopacity / 100})  ${setinset()};`}</p>
                    </div>
                    <button id="copyBtn" onClick={copy}>Copy</button>
                </div>
                <div className="right">
                    <p>A box-shadow CSS generator that helps you quickly generate box-shadow CSS declarations for your website. It comes with many options and it demonstrates instantly.</p>
                </div>
            </div>
        </div>
    )
};

export default MainContent;